import { TGamesPushAction } from '@interlayer/js/app/store/reducers/recentlyGames/types';

import { actionTypes } from './constants';

type Action<T extends actionTypes, P> = {
    type: T;
    payload: P;
};

export const setRecentlyPlayedAction = (gameCodes: string[]): Action<actionTypes.SET_RECENTLY_PLAYED, string[]> => ({
    type: actionTypes.SET_RECENTLY_PLAYED,
    payload: gameCodes
});

export const gamesPushAction = (payload: TGamesPushAction): Action<actionTypes.GAMES_PUSH, TGamesPushAction> => ({
    type: actionTypes.GAMES_PUSH,
    payload
});

export const resetRecentlyGames = (): { type: actionTypes.RESET_RECENTLY_GAMES } => ({
    type: actionTypes.RESET_RECENTLY_GAMES
});
